import axios from "../utils/axios";

// 🏢 EPayment checkout
export const checkoutPayment = async (payment) => {
  // payment object structure
  // {
  //   "userId": "string",
  //   "cartIds": "string",
  //   "voucherCode": "string",
  //   "paymentMethod": 0
  // }

  const response = await axios.post("/api/Payment/EPayment", payment);
  //console.log(response);
  return response.data;
};

// 🏢 Get invoice order
export const getInvoiceByUser = async (req) => {
  // Status Enum
  // public enum InvoiceStatus
  //  {
  //      [Description("Waiting For Payment")]
  //      WaitingForPayment = 0,
  //      [Description("Payment Failed")]
  //      PaymentFailed = 1,
  //      [Description("Payment Success")]
  //      PaymentSuccess = 2,
  //      [Description("Payment Expired")]
  //      Expired = 3,
  //      Pending = 4
  //  }
  const response = await axios.get("/api/Payment/GetInvoiceByUser", {
    params: {
      userId: req.userId,
      status: req.status || null,
    },
  });
  //console.log(response);
  return response.data;
};

// 🏢 Get invoice single
export const getSingleInvoiceById = async (invId) => {
  // Status Enum
  // public enum InvoiceStatus
  //  {
  //      [Description("Waiting For Payment")]
  //      WaitingForPayment = 0,
  //      [Description("Payment Failed")]
  //      PaymentFailed = 1,
  //      [Description("Payment Success")]
  //      PaymentSuccess = 2,
  //      [Description("Payment Expired")]
  //      Expired = 3,
  //      Pending = 4
  //  }
  const response = await axios.get("/api/Payment/GetInvoice", {
    params: {
      invoiceId: invId
    },
  });
  //console.log(response);
  return response.data;
};

// 🏢 Upload invoice proof
export const uploadInvoiceProof = async (invoiceId, image) => {
  const response = await axios.post(`/api/Payment/UploadInvoiceProof?invoiceId=${invoiceId}&image=${image}`);
  //console.log(response);
  return response;
};

// 🏢 Update invoice status
export const updateInvoice = async (invoiceId, status) => {
  const response = await axios.post(`/api/Payment/ChangeInvoiceStatus?invoiceId=${invoiceId}&status=${status}`);
  //console.log(response);
  return response;
};